import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=7c66dd65&scoped=true&"
import script from "./JobItem.vue?vue&type=script&lang=js&"
export * from "./JobItem.vue?vue&type=script&lang=js&"
import style0 from "./JobItem.vue?vue&type=style&index=0&id=7c66dd65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c66dd65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
